import { IObject } from '../contexts/EditorContext';
import { EBorderType } from '../components/Viewport/fabric/extendCustomObject';

const getObjectBorder = (obj:IObject['object'], border: EBorderType) => obj.showBorder === EBorderType.ERROR ? EBorderType.ERROR : border;

export default getObjectBorder;
